module.exports = __webpack_public_path__ + "static/Dafiti3-0be6bdcefe0bf797edf22171f8651097.png";